/**
 * Global "saving for offline" indicator (app shell, under the offline banner): pack name, files and
 * percentage, "Haltu appinu opnu á meðan". Tapping opens the storage settings.
 */
import { CloudDownload, WifiOff } from 'lucide-react';
import { Link } from 'react-router';
import { useI18n } from '../i18n';
import { percent, packTitle } from './format';
import { useOfflineSnapshot } from './hooks';

export function DownloadsBar() {
  const { t } = useI18n();
  const { progress } = useOfflineSnapshot();
  if (!progress) return null;
  const pct = percent(progress.bytesDone, progress.bytesTotal);
  const title = packTitle(t, { kind: progress.packKind, title: progress.packTitle });
  const waiting = progress.waiting;
  return (
    <Link
      to="/settings#settings-offline"
      className="relative flex min-h-11 items-center gap-3 overflow-hidden border-b border-[var(--line)] bg-[var(--accent-soft)] px-4 py-1.5 text-[15px] text-[var(--ink)]"
      aria-live="polite"
    >
      <span
        className="absolute inset-y-0 left-0 bg-[var(--accent)]/15 transition-[width] duration-500"
        style={{ width: `${pct}%` }}
        aria-hidden
      />
      {waiting === 'network' ? (
        <WifiOff className="relative size-5 shrink-0 text-[var(--muted)]" aria-hidden />
      ) : (
        <CloudDownload className="relative size-5 shrink-0 animate-pulse text-[var(--accent)]" aria-hidden />
      )}
      <span className="relative min-w-0 flex-1 truncate font-semibold">{t('offline.bar_saving', { title })}</span>
      <span className="relative hidden shrink-0 text-[var(--ink-2)] sm:inline">
        {waiting ? t(waiting === 'network' ? 'offline.waiting_network' : 'offline.waiting_retry') : t('offline.keep_open')}
      </span>
      <span className="relative shrink-0 font-semibold text-[var(--accent)] tabular-nums">{t('offline.percent', { percent: pct })}</span>
    </Link>
  );
}
